import { createContext } from 'react';
import { DraggableContext } from './types';

export const SortableItemContext = createContext<DraggableContext>({
  attributes: {
    role: 'button',
    tabIndex: 0,
    'aria-disabled': false,
    'aria-pressed': false,
    'aria-describedby': undefined,
    'aria-roledescription': 'sortable',
  },
  listeners: undefined,
  ref: () => {},
});
